import { render } from "./FormPassword.vue?vue&type=template&id=705420fa&scoped=true"
import script from "./FormPassword.vue?vue&type=script&lang=js"
export * from "./FormPassword.vue?vue&type=script&lang=js"

import "./FormPassword.vue?vue&type=style&index=0&id=705420fa&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-705420fa"

export default script